import { render } from "./UiJsonEditor.pug?vue&type=template&id=65630fd4&lang=pug"
import script from "./UiJsonEditor.js?vue&type=script&lang=js"
export * from "./UiJsonEditor.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__